<template>
  <v-container
    id="descricao-produtos-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <base-material-card
          :color="corPrimaria"
          :app-online="appOnline"
          class="py-3 px-5"
        >
          <template v-slot:heading>
            <div
              class="text-h3 font-bold-light"
            >
              Detalhes do Produto
            </div>
          </template>
        </base-material-card>
        <v-divider class="mb-5" />
        <v-row>
          <v-col
            cols="12"
            lg="5"
          >
            <div class="col-12">
              <div
                v-if="imagens"
              >
                <v-img
                  id="imagemDetalhe"
                  :src="imagemPrincipal"
                  contain
                />
                <v-row>
                  <ul id="ul_imagensDetalhe">
                    <li
                      v-for="imagem in imagens"
                      id="li_imagens"
                      :key="imagem.id"
                    >
                      <v-img
                        id="imagemCardDetalhe"
                        :src="imagem.imagem"
                        contain
                        :style="imagem.select ? styleObject : null"
                        @click="selecionarImagem(imagem)"
                      />
                    </li>
                  </ul>
                </v-row>
              </div>
            </div>
          </v-col>
          <v-col
            cols="12"
            lg="7"
          >
            <div
              v-if="dadosProduto"
            >
              <v-row>
                <span id="produtoNome_desc">{{ dadosProduto.nome }} ({{ dadosProduto.unidade }})</span>
              </v-row>
              <v-row>
                <span
                  v-if="dadosProduto.linhaNome"
                  id="linhaNome_desc"
                >
                  Linha de Produção: {{ dadosProduto.linhaNome }}
                </span>
              </v-row>
              <v-row>
                <span
                  v-if="dadosProduto.classificacaoNome"
                  id="classificacaoNome_desc"
                >
                  Classificação: {{ dadosProduto.classificacaoNome }}
                </span>
              </v-row>
              <v-row>
                <span
                  v-if="dadosProduto.pecasPorCaixa"
                  id="pecasCaixa_desc"
                >
                  Peças por caixa: {{ dadosProduto.pecasPorCaixa }}
                </span>
              </v-row>
              <v-row v-if="!exibirCaixa">
                <span
                  v-if="dadosProduto.caixas"
                  id="caixa_desc"
                >
                  Caixas: {{ dadosProduto.caixas }}
                </span>
              </v-row>
              <v-row v-if="!exibirPecas">
                <span
                  v-if="dadosProduto.pecas"
                  id="caixa_desc"
                >
                  Peça(s): {{ dadosProduto.pecas }}
                </span>
              </v-row>
              <v-row v-if="!exibirQuantidade">
                <span
                  v-if="dadosProduto.quantidade"
                  id="caixa_desc"
                >
                  Quantidade(s): {{ dadosProduto.quantidade }} ({{ dadosProduto.unidade }})
                </span>
              </v-row>
              <v-row v-if="dadosProduto.referenciaUnidade !== 1">
                <span
                  id="caixa_desc"
                >
                  Aproximadamente {{ dadosProduto.referenciaUnidade }} {{ dadosProduto.unidade }} por peça
                </span>
              </v-row>
              <v-row>
                <span id="precoProduto_desc">
                  Preço: R$ {{ dadosProduto.precoExibicao }}/{{ dadosProduto.unidade }}
                </span>
              </v-row>
              <v-row v-if="dadosProduto.subtotal">
                <span
                  id="subtotal_desc"
                >
                  Subtotal: {{ dadosProduto.subtotal }}
                </span>
              </v-row>
              <v-row>
                <span
                  v-if="exibirCaixa"
                  id="pecaQuantidade_desc"
                >
                  Caixa(s)
                </span>
                <span
                  v-if="exibirPecas"
                  id="pecaQuantidade_desc"
                >
                  Peça(s)
                </span>
                <span
                  v-if="exibirQuantidade"
                  id="pecaQuantidade_desc"
                >
                  Quantidade(s)
                </span>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  lg="2"
                >
                  <input
                    v-if="exibirCaixa"
                    id="input_cart_desc"
                    v-model="dadosProduto.caixas"
                    pattern="^[0-9]"
                    type="number"
                    class="text-center"
                    @keyup="dadosProduto.caixas < 0 ? removeItem(dadosProduto) : addItemKeyup(dadosProduto)"
                  >
                  <input
                    v-if="exibirPecas"
                    id="input_cart_desc"
                    v-model="dadosProduto.pecas"
                    pattern="^[0-9]"
                    type="number"
                    class="text-center"
                    @keyup="dadosProduto.pecas < 0 ? removeItem(dadosProduto) : addItemKeyup(dadosProduto)"
                  >
                  <input
                    v-if="exibirQuantidade"
                    id="input_cart_desc"
                    v-model="dadosProduto.quantidade"
                    pattern="^[0-9]"
                    type="number"
                    class="text-center"
                    @keyup="dadosProduto.quantidade < 0 ? removeItem(dadosProduto) : addItemKeyup(dadosProduto)"
                  >
                </v-col>
                <v-col
                  cols="12"
                  lg="3"
                >
                  <v-btn
                    id="btnAdd_desc"
                    small
                    :color="corSecondaria"
                    dark
                    @click="addItem(dadosProduto)"
                  >
                    <v-icon color="#ffffff">
                      mdi-plus
                    </v-icon>
                  </v-btn><br>
                  <v-btn
                    id="btnAdd_desc"
                    small
                    :color="corError"
                    dark
                    @click="removeItem(dadosProduto)"
                  >
                    <v-icon color="#ffffff">
                      mdi-minus
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-col
                  cols="2"
                  lg="2"
                >
                  <v-btn
                    id="btnProduto_desc"
                    :color="corPrimaria"
                    dark
                    @click="addCarrinho(dadosProduto)"
                  >
                    Adicionar
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
        <hr><br>
        <v-row
          class="mb-6"
          justify="center"
          no-gutters
        >
          <v-tabs
            v-if="dadosProduto.descricao"
            id="tabs"
            fixed-tabs
            :background-color="corPrimaria"
            dark
          >
            <v-tab
              v-if="dadosProduto.descricao"
              @click="Descricao()"
            >
              Descrição
            </v-tab>
          </v-tabs>
        </v-row>
        <v-row no-gutters>
          <v-col
            md="8"
            offset-md="2"
          >
            <div
              v-if="descricaoShow"
              id="descricaoProduto_desc"
            >
              {{ dadosProduto.descricao }}
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
    <v-dialog
      v-model="dialog.visible"
      max-width="411"
      persistent
    >
      <v-card>
        <v-card-title>
          <v-spacer />
          <v-icon
            aria-label="Close"
            @click="dialog.visible = false"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="text-center">
          {{ dialog.message }}
        </v-card-text>
        <v-card-text class="pb-3 pt-6 text-center">
          <v-btn
            class="mr-3"
            :color="corError"
            text
            @click="resetProduto(dialog.produto), dialog.visible = false"
          >
            Não
          </v-btn>

          <v-btn
            :color="corSecondaria"
            text
            @click="confirmRemoveProduto(dialog.produto) ,dialog.visible = false"
          >
            Sim
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import utils from '../../../services/utils'
  import ListaProdutos from '../../../services/listaprodutosservice'
  import Carrinho from '../../../services/carrinhoservice'
  import Imagem from '../../../services/imagemservice'

  export default {
    name: 'PageDescricaoProdutos',
    emits: ['updateCart'],
    components: {
      DashboardCoreSnackbar: () => import('../components/core/Snackbar'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      produtoId: localStorage.produtoId,
      valid: true,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      corError: localStorage.corError,
      dadosProduto: [],
      styleObjectError: {
        color: localStorage.corError,
      },
      styleObject: {
        color: localStorage.corPrimaria,
        border: 'solid 2px',
      },
      carrinho: [],
      itensCarrinho: [],
      cart: 0,
      imagens: [],
      imagemPrincipal: '',
      descricaoShow: true,
      carrinhoId: localStorage.carrinhoId ? localStorage.carrinhoId : 0,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      exibirCaixa: false,
      exibirPecas: false,
      exibirQuantidade: false,
      dialog: {
        visible: false,
        message: '',
      },
    }),

    mounted () {
      if (localStorage.chaveativacao && localStorage.chaveativacao !== 'undefined') {
        this.chaveativacao = localStorage.chaveativacao
        if (localStorage.getItem('usuarioIdentificado') && localStorage.getItem('usuarioIdentificado') === 'true') {
          this.usuarioIdentificado = true

          this.showDescricao()
          this.showImagem()
        } else {
          this.usuarioIdentificado = false
          localStorage.removeItem('username')
          localStorage.removeItem('email')
          localStorage.removeItem('nome')
          this.$router.push('/login')
        }
      } else {
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        this.$router.push('/login')
      }
    },

    methods: {
      async showDescricao () {
        await ListaProdutos.showDescricao(this.produtoId, localStorage.username, localStorage.contrato_id, this.carrinhoId).then(resposta => {
          if (resposta.data.status) {
            if (resposta.data.exibirCaixa) {
              this.exibirCaixa = resposta.data.exibirCaixa
            } else if (resposta.data.exibirPecas) {
              this.exibirPecas = resposta.data.exibirPecas
            } else if (resposta.data.exibirQuantidade) {
              this.exibirQuantidade = resposta.data.exibirQuantidade
            }

            const dados = {
              id: resposta.data.dados.id,
              idProduto: resposta.data.dados.idProduto,
              nome: resposta.data.dados.nome,
              unidade: resposta.data.dados.unidade,
              preco: resposta.data.dados.preco,
              precoExibicao: resposta.data.dados.precoExibicao,
              linha_id: resposta.data.dados.linha_id,
              linhaNome: resposta.data.dados.linhaNome,
              idClassificacao: resposta.data.dados.idClassificacao,
              classificacaoNome: resposta.data.dados.classificacaoNome,
              pecasPorCaixa: resposta.data.dados.pecasPorCaixa,
              precoForaUf: resposta.data.dados.precoForaUf,
              pesoLiquido: resposta.data.dados.pesoLiquido,
              pesoBruto: resposta.data.dados.pesoBruto,
              descricao: resposta.data.dados.descricao,
              referenciaUnidade: resposta.data.dados.referenciaUnidade.toFixed(2),
              peso: resposta.data.dados.peso,
              dataInicioPromocao: resposta.data.dados.dataInicioPromocao,
              dataFimPromocao: resposta.data.dados.dataFimPromocao,
              pecas: resposta.data.dados.pecas,
              caixas: resposta.data.dados.caixas,
              quantidade: parseFloat(resposta.data.dados.quantidade).toFixed(2),
              subtotal: (parseFloat(resposta.data.dados.quantidade) * parseFloat(resposta.data.dados.preco.replace(',', '.')).toFixed(2)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            }

            this.dadosProduto = dados
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      async showImagem () {
        await Imagem.showImagem(this.produtoId, localStorage.contrato_id).then(resposta => {
          if (resposta.data.status) {
            this.imagens = resposta.data.imagens
            this.imagemPrincipal = this.imagens[0].imagem
            this.imagens[0].select = true
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      async addCarrinho (dadosProduto) {
        if (this.exibirPecas && dadosProduto.pecas <= 0) {
          alert('Favor informar um valor maior que 0 para peças')

          dadosProduto.pecas = 1
          dadosProduto.caixas = Math.ceil(dadosProduto.pecas / dadosProduto.pecasPorCaixa)
          dadosProduto.quantidade = dadosProduto.referenciaUnidade
          dadosProduto.subtotal = (parseFloat(dadosProduto.quantidade) * parseFloat(dadosProduto.preco)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } else if (this.exibirCaixa && dadosProduto.caixas <= 0) {
          alert('Favor informar um valor maior que 0 para caixas')

          dadosProduto.caixas = 1

          dadosProduto.pecas = dadosProduto.caixas * dadosProduto.pecasPorCaixa
          dadosProduto.quantidade = (dadosProduto.referenciaUnidade * dadosProduto.pecasPorCaixa) * dadosProduto.caixas
          dadosProduto.subtotal = (parseFloat(dadosProduto.quantidade) * parseFloat(dadosProduto.preco)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } else if (this.exibirQuantidade && dadosProduto.quantidade <= 0) {
          alert('Favor informar um valor maior que 0 para quantidade')

          dadosProduto.quantidade = 1
          dadosProduto.subtotal = (parseFloat(dadosProduto.quantidade) * parseFloat(dadosProduto.preco)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

          dadosProduto.pecas = Math.ceil(dadosProduto.quantidade / dadosProduto.referenciaUnidade)
          dadosProduto.caixas = dadosProduto.caixas ? Math.ceil((dadosProduto.quantidade / dadosProduto.referenciaUnidade) / dadosProduto.pecasPorCaixa) : 0
        } else {
          await Carrinho.addItemCarrinho(dadosProduto, localStorage.username, localStorage.tokencontrato).then(resposta => {
            this.carrinho = resposta.data.carrinho
            this.itensCarrinho = resposta.data.itensCarrinho
            this.cart = this.itensCarrinho.length

            this.updateCart()
            this.$router.push('/lista-produtos')
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          })
        }
      },

      selecionarImagem (imagem) {
        this.imagemPrincipal = imagem.imagem

        this.imagens = this.imagens.map((lista) => {
          var listaimagens = ({
            id: lista.id,
            idImagem: lista.idImagem,
            principal: lista.principal,
            imagem: lista.imagem,
            select: lista.id === imagem.id ? true : null,
          })

          return listaimagens
        })

        imagem.select = true
      },

      addItem (produto) {
        if (this.exibirCaixa) {
          produto.caixas = produto.caixas ? parseFloat(produto.caixas) : 0

          produto.caixas += 1

          produto.pecas = produto.caixas * produto.pecasPorCaixa
          produto.quantidade = ((produto.referenciaUnidade * produto.pecasPorCaixa) * produto.caixas).toFixed(2)

          produto.subtotal = (parseFloat(produto.quantidade) * parseFloat(produto.preco.replace(',', '.')).toFixed(2)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } else if (this.exibirPecas) {
          produto.pecas = parseFloat(produto.pecas)

          produto.pecas += 1

          produto.caixas = produto.caixas ? Math.ceil(produto.pecas / produto.pecasPorCaixa) : produto.caixas
          produto.quantidade = (produto.pecas * produto.referenciaUnidade).toFixed(2)

          produto.subtotal = (parseFloat(produto.quantidade) * parseFloat(produto.preco.replace(',', '.')).toFixed(2)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } else if (this.exibirQuantidade) {
          produto.quantidade = parseFloat(produto.quantidade)

          produto.quantidade += 1

          produto.subtotal = (parseFloat(produto.quantidade) * parseFloat(produto.preco.replace(',', '.')).toFixed(2)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

          produto.pecas = Math.ceil(produto.quantidade / produto.referenciaUnidade)
          produto.caixas = produto.caixas ? Math.ceil((produto.quantidade / produto.referenciaUnidade) / produto.pecasPorCaixa) : 0
        }
      },

      addItemKeyup (produto) {
        if (this.exibirCaixa) {
          produto.caixas = produto.caixas ? parseFloat(produto.caixas) : 0

          produto.pecas = produto.caixas * produto.pecasPorCaixa
          produto.quantidade = ((produto.referenciaUnidade * produto.pecasPorCaixa) * produto.caixas).toFixed(2)

          produto.subtotal = (parseFloat(produto.quantidade) * parseFloat(produto.preco.replace(',', '.')).toFixed(2)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } else if (this.exibirPecas) {
          produto.pecas = parseFloat(produto.pecas)

          produto.caixas = produto.caixas ? Math.ceil(produto.pecas / produto.pecasPorCaixa) : 0
          produto.quantidade = (produto.pecas * produto.referenciaUnidade).toFixed(2)

          produto.subtotal = (parseFloat(produto.quantidade) * parseFloat(produto.preco.replace(',', '.')).toFixed(2)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } else if (this.exibirQuantidade) {
          produto.quantidade = parseFloat(produto.quantidade)

          produto.subtotal = (parseFloat(produto.quantidade) * parseFloat(produto.preco.replace(',', '.')).toFixed(2)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

          produto.pecas = Math.ceil(produto.quantidade / produto.referenciaUnidade)
          produto.caixas = produto.caixas ? Math.ceil((produto.quantidade / produto.referenciaUnidade) / produto.pecasPorCaixa) : 0
        }
      },

      removeItem (produto) {
        if (this.exibirCaixa) {
          produto.caixas = Math.max(produto.caixas - 1, 0)

          produto.pecas = produto.caixas * produto.pecasPorCaixa
          produto.quantidade = (produto.referenciaUnidade * produto.pecasPorCaixa * produto.caixas).toFixed(2)

          produto.subtotal = (parseFloat(produto.quantidade) * parseFloat(produto.preco.replace(',', '.')).toFixed(2)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } else if (this.exibirPecas) {
          produto.pecas = Math.max(produto.pecas - 1, 0)

          produto.caixas = produto.caixas ? Math.ceil(produto.pecas / produto.pecasPorCaixa) : 0
          produto.quantidade = (produto.pecas * produto.referenciaUnidade).toFixed(2)

          produto.subtotal = (parseFloat(produto.quantidade) * parseFloat(produto.preco.replace(',', '.')).toFixed(2)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } else if (this.exibirQuantidade) {
          produto.quantidade = Math.max(produto.quantidade - 1, 0)

          produto.subtotal = (parseFloat(produto.quantidade) * parseFloat(produto.preco.replace(',', '.')).toFixed(2)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

          produto.pecas = Math.ceil(produto.quantidade / produto.referenciaUnidade)
          produto.caixas = produto.caixas ? Math.ceil(produto.quantidade / (produto.referenciaUnidade * produto.pecasPorCaixa)) : 0
        }
      },

      /* Método que atualiza o ícone da quantidade itens no pedido */
      updateCart () {
        this.$root.$emit('update-cart', this.cart)
      },

      Descricao () {
        if (this.descricaoShow) {
          this.descricaoShow = false
        } else {
          this.descricaoShow = true
        }
        this.caracteristicaShow = false
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      showDialog (timeout, message, produto) {
        this.dialog.visible = true
        this.dialog.timeout = timeout
        this.dialog.message = message
        this.dialog.produto = produto
      },
    },
  }
</script>

<style lang="sass">
  #imagemDetalhe
    margin: auto
    display: grid
    width: 256px
    height: 256px
    position: relative

  #input_cart_desc
    width: 3rem
    height: 4rem
    border: 2px solid #e1e1e1

  input[type=number]::-webkit-inner-spin-button
    -webkit-appearance: none

  input[type=number]
    -moz-appearance: textfield
    appearance: textfield

  #divBtn_desc
    margin: -4rem 3.5rem auto

  #btnAdd_desc
    margin: 0 -4.5rem auto
    border-radius: 1.8rem
    float: none

  #btnProduto_desc
    margin: 0.5rem -12rem auto
    border-radius: 1.8rem
    float: none

  #produtoNome_desc
    font-size: 30px
    align-items: left
    font-weight: bold
    display: flex

  #linhaNome_desc
    display: flex
    color: gray

  #classificacaoNome_desc
    display: flex
    color: gray

  #pecasCaixa_desc
    display: flex
    color: gray

  #caixa_desc
    display: flex
    color: gray

  #precoProduto_desc
    font-size: 30px
    align-items: left
    display: flex

  #pecaQuantidade_desc
    display: grid
    align-items: left
    margin-left: 1rem
    font-size: 20px
    color: gray

  #subtotal_desc
    display: grid
    align-items: left
    font-size: 20px

  #caracteriscaProduto_desc
    font-size: 14px
    color: gray
    text-align: justify

  #descricaoProduto_desc
    font-size: 14px
    color: gray
    text-align: justify

  #titulo_desc
    font-size: 22px
    color: gray
    font-weight: bold
    margin-left: -10rem

  #btnCaracteristicas_desc
    border-radius: 1.8rem
    float: none
    display: flex
    width: 11rem

  #btnDescricao_desc
    border-radius: 1.8rem
    float: none
    display: flex
    width: 11rem

  #tabs
    margin-left: 12rem
    margin-right: 12rem

  #imagemCardDetalhe
    margin: auto
    display: grid
    width: 60px
    height: 60px

  #imagemCard:hover
    top:-2px
    box-shadow:2px 2px 2px #2196F3

  #ul_imagensDetalhe
    list-style-type: none
    display: flex

  #li_imagens
    margin: 1.25rem

</style>
